export const interpolatePrice = (price: string[], format: string) => {
  const regex = /%p/g
  let index = 0
  return format.replace(regex, () => price[index++])
}
